import { Prop, Component, h, Method } from "@stencil/core";
import { ButtonWithBadgeProps } from "./f-button-with-badge-model";

@Component({
  tag: "f-button-with-badge",
  styleUrl: "f-button-with-badge.scss",
  shadow: true,
})
export class FButtonWithBadge {
  private button: HTMLFButtonElement;

  @Prop() badgeLabel: ButtonWithBadgeProps["badgeLabel"];
  @Prop() iconName: ButtonWithBadgeProps["iconName"] = "notification-active";
  @Prop() iconPosition: ButtonWithBadgeProps["iconPosition"];
  @Prop() buttonTitle: ButtonWithBadgeProps["buttonTitle"];
  @Prop() iconOnly: ButtonWithBadgeProps["iconOnly"] = true;

  @Method()
  async focusOnButton(): Promise<void> {
    window.setTimeout(() => {
      this.button.focus();
    }, 0);
  }

  render() {
    return (
      <f-button
        variant="integrated"
        ref={(el) => (this.button = el)}
        iconOnly={this.iconOnly}
        buttonTitle={this.buttonTitle}
        data-test={`btn-${this.buttonTitle?.toLowerCase() || ""}`}
      >
        <span
          class={{
            "f-button-with-badge__icon": true,
            "f-button-with-badge__icon-reverse": this.iconPosition === "right",
          }}
        >
          <f-icon iconName={this.iconName} />
          {this.badgeLabel ? (
            <f-badge
              data-test={`badge-${this.buttonTitle?.toLowerCase() || ""}`}
            >
              {this.badgeLabel}
            </f-badge>
          ) : (
            ""
          )}
          <slot />
        </span>
      </f-button>
    );
  }
}
